import { FC } from 'react';
import { Icon } from 'common-components';
import styles from './credentialsHelper.module.scss';
import { useTranslationContext } from '../../contexts/translationContext';

const CredentialsHelper: FC = () => {
    const { translate } = useTranslationContext();

    const WHERE_TO_PASTE_VALUES = translate('WhereToPasteValues');

    return (
        <div className={styles.container}>
            <Icon name={'authKeys'} isPng={true} style={{ display: 'flex', height: '3.8rem' }} />
            <div className={styles.content}>
                <div className={styles['helper-title']}>
                    <Icon name={'alertIconPurpleAdmin'} style={{ display: 'flex', width: '0.8rem' }} />
                    <span>{WHERE_TO_PASTE_VALUES}</span>
                </div>
                <div className={styles.headers}>
                    <div className={styles.header}>
                        <span className={styles.title}>Authorization: </span>
                        <span className={styles.prefix}>&apos;Bearer </span>
                        <span className={styles['placeholder-title']}>{'<token>'}</span>
                        <span className={styles.prefix}>&apos;</span>
                    </div>
                    <div className={styles.header}>
                        <span className={styles.title}>X-API-Key: </span>
                        <span className={styles['placeholder-title']}>{'<api-key>'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CredentialsHelper;
